
import waveMic from "../../assets/thinking.gif";
import VoiceModeMicIcon from "../../assets/icons/voiceModeMic";
import PropTypes from "prop-types";

export default function MicButton({ active, onClick }) {
  return active ? (
    <img src={waveMic} alt="Active microphone" width="200" height="200" />
  ) : (
    <button
      onClick={onClick}
      aria-label="Start voice input"
      className={`mic-button flex items-center justify-center rounded-full focus:outline-none bg-[#1B5C29] w-[170px] h-[170px] border-none outline-none shadow-[0_0_24px_0_#0002] ${
        active ? "active-animation" : ""
      }`}
      // style={{
      //   background: "#1B5C29",
      //   width: 170,
      //   height: 170,
      //   border: "none",
      //   outline: "none",
      //   boxShadow: "0 0 24px 0 #0002",
      // }}
    >
      <VoiceModeMicIcon color="#ffffff" />
    </button>
  );
}

MicButton.propTypes = {
  active: PropTypes.bool,
  onClick: PropTypes.func,
};
